__turbopack_context__.v({
  "bulletItem": "PlanCard-module__ZPYAga__bulletItem",
  "bulletList": "PlanCard-module__ZPYAga__bulletList",
  "cardContainer": "PlanCard-module__ZPYAga__cardContainer",
  "checkIconWrapper": "PlanCard-module__ZPYAga__checkIconWrapper",
  "checklistContainer": "PlanCard-module__ZPYAga__checklistContainer",
  "checklistItem": "PlanCard-module__ZPYAga__checklistItem",
  "checklistLabel": "PlanCard-module__ZPYAga__checklistLabel",
  "chevronDown": "PlanCard-module__ZPYAga__chevronDown",
  "compactHeaderRow": "PlanCard-module__ZPYAga__compactHeaderRow",
  "defaultHeaderRow": "PlanCard-module__ZPYAga__defaultHeaderRow",
  "descRecoveryBlock": "PlanCard-module__ZPYAga__descRecoveryBlock",
  "detailsToggle": "PlanCard-module__ZPYAga__detailsToggle",
  "discountBadge": "PlanCard-module__ZPYAga__discountBadge",
  "headerRow": "PlanCard-module__ZPYAga__headerRow",
  "includesHeader": "PlanCard-module__ZPYAga__includesHeader",
  "includesInner": "PlanCard-module__ZPYAga__includesInner",
  "includesWrapper": "PlanCard-module__ZPYAga__includesWrapper",
  "inlinePriceRow": "PlanCard-module__ZPYAga__inlinePriceRow",
  "learnMoreChevron": "PlanCard-module__ZPYAga__learnMoreChevron",
  "metaDot": "PlanCard-module__ZPYAga__metaDot",
  "metaRow": "PlanCard-module__ZPYAga__metaRow",
  "nameDescBlock": "PlanCard-module__ZPYAga__nameDescBlock",
  "onRequestLabel": "PlanCard-module__ZPYAga__onRequestLabel",
  "originalPrice": "PlanCard-module__ZPYAga__originalPrice",
  "planDescription": "PlanCard-module__ZPYAga__planDescription",
  "planName": "PlanCard-module__ZPYAga__planName",
  "price": "PlanCard-module__ZPYAga__price",
  "priceButtonWrapper": "PlanCard-module__ZPYAga__priceButtonWrapper",
  "priceRow": "PlanCard-module__ZPYAga__priceRow",
  "quantityButton": "PlanCard-module__ZPYAga__quantityButton",
  "quantityControlsWrapper": "PlanCard-module__ZPYAga__quantityControlsWrapper",
  "quantityValue": "PlanCard-module__ZPYAga__quantityValue",
  "recoveryNote": "PlanCard-module__ZPYAga__recoveryNote",
  "serviceAddButton": "PlanCard-module__ZPYAga__serviceAddButton",
  "serviceCardContainer": "PlanCard-module__ZPYAga__serviceCardContainer",
  "serviceDescription": "PlanCard-module__ZPYAga__serviceDescription",
  "serviceName": "PlanCard-module__ZPYAga__serviceName",
  "serviceNameBlock": "PlanCard-module__ZPYAga__serviceNameBlock",
  "servicePrice": "PlanCard-module__ZPYAga__servicePrice",
  "serviceSeparator": "PlanCard-module__ZPYAga__serviceSeparator",
  "sessionInfo": "PlanCard-module__ZPYAga__sessionInfo",
  "thumbnail": "PlanCard-module__ZPYAga__thumbnail",
  "thumbnailPlaceholder": "PlanCard-module__ZPYAga__thumbnailPlaceholder",
  "validityBadge": "PlanCard-module__ZPYAga__validityBadge",
});
